// Ne JAMAIS deviner la "vue". On ne renvoie une variante
// que si elle a été fournie explicitement par le backend.
export function classify(desc = '', backendVariant = null) {
  const d = String(desc).toLowerCase();

  const baseType =
    /single/.test(d) ? 'Single' :
    /double|twin/.test(d) ? 'Double' :
    /triple|trpl|trp/.test(d) ? 'Triple' :
    /quadruple|quad|4\s*(pax|pers|beds?)/.test(d) ? 'Quadruple' :
    'Autre';

  // Si le back a déjà une variante claire, on la respecte.
  const variant =
    backendVariant && String(backendVariant).trim()
      ? String(backendVariant).trim()
      : 'Standard';

  return { baseType, variant };
}
